import React from 'react'
import { useParams } from 'react-router-dom';
import { useGetOfferOptionByIdQuery, useUpdateOfferOptionMutation } from '../Service/offerOptionsApi';
import { useEntityForm } from '../../Shared/Hooks/useEntityForm';
import { OfferOptionType } from '../Types/offerOptionsTypes';
import { offerOptionTypeFields } from '../fields';
import { OfferOptionsRoutes } from '../../../Router/path';
import InfoIcon from "@mui/icons-material/Info";
import SettingsIcon from "@mui/icons-material/Settings";
import theme from '../../../theme';
import { CircularProgress, Typography } from '@mui/material';
import { offerOptionTypeValues } from '../initialValues';
import EntityFormLayout from '../../Shared/Components/EntityFormLayout/EntityFormLayout';
import { FormRenderGroupTypes } from '../../Shared/Components/FormRenderer/FormRenderGroup.types';

const EditOfferOptions = () => {
    const offerOptionId = parseInt(useParams<{ offerOptionId: string }>().offerOptionId!);
    const { data: optionTypeData, isLoading, error } = useGetOfferOptionByIdQuery(offerOptionId, {
        skip: !offerOptionId,
    });
    const [updateOfferOption, updateStatus] = useUpdateOfferOptionMutation();

    const entityForm = useEntityForm<OfferOptionType>({
        initialData: (optionTypeData as unknown as OfferOptionType) ?? offerOptionTypeValues,
        fields: offerOptionTypeFields,
        submitFn: (data) => updateOfferOption({ id: offerOptionId, data }).unwrap(),
        redirectUrl: OfferOptionsRoutes.root,
        title: "Edytuj typ opcji",
        icon: <SettingsIcon sx={{ color: theme.palette.primary.main }} />,
        backUrl: OfferOptionsRoutes.root,
        groupOrder: [FormRenderGroupTypes.basic, FormRenderGroupTypes.values],
        groupIcons: {
            [FormRenderGroupTypes.basic]: <InfoIcon sx={{ color: theme.palette.primary.main }} />,
            [FormRenderGroupTypes.values]: <SettingsIcon sx={{ color: theme.palette.primary.main }} />,
        },
        mutationStatus: updateStatus,
    });

    if (isLoading) {
        return (
            <Typography align="center" sx={{ mt: 4 }}>
                <CircularProgress />
            </Typography>
        );
    }
    if (error) {
        return (
            <Typography color="error" align="center" sx={{ mt: 4 }}>
                Nie udało się załadować danych typu opcji.
            </Typography>
        );
    }


    return (
        <EntityFormLayout {...entityForm} />
    )
}

export default EditOfferOptions